import { monthLabelShort } from "../../lib/overview-period";

interface MonthSelectorProps {
  value: string;
  onChange: (month: string) => void;
  months: string[];
  className?: string;
  disabled?: boolean;
}

export function MonthSelector({
  value,
  onChange,
  months,
  className = "",
  disabled = false,
}: MonthSelectorProps) {
  return (
    <select
      aria-label="Reporting month"
      className={["edlab-select text-sm", className].join(" ")}
      value={value}
      disabled={disabled || months.length === 0}
      onChange={(event) => {
        onChange(event.target.value);
      }}
    >
      {months.map((month) => (
        <option key={month} value={month}>
          {monthLabelShort(month)}
        </option>
      ))}
    </select>
  );
}
